import { enqueueSnackbar, UploadMultipleFiles } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetConfigurationManagementSummaryTableRequest
} from '../requests/ConfigurationManagementRequests.js';

export const GET_CONFIGURATION_MANAGEMENT_SUMMARY_TABLE = 'GET_CONFIGURATION_MANAGEMENT_SUMMARY_TABLE';

const onGetConfigurationManagementSummaryTable = (value) => ({
	type: GET_CONFIGURATION_MANAGEMENT_SUMMARY_TABLE,
	configurationManagementSummaryTableData: value
});

export const GetConfigurationManagementSummaryTable = () => async (dispatch) => {
	await GetConfigurationManagementSummaryTableRequest().then(response => {
		dispatch(onGetConfigurationManagementSummaryTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
